import { render } from "./artikel.vue?vue&type=template&id=234107fb"
import script from "./artikel.vue?vue&type=script&lang=js"
export * from "./artikel.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dinaskominfo/Documents/Project/Vue/Erida/eridaApp/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QIcon,QCard,QCardSection,QCardActions,QBtn,QTooltip,QDialog});qInstall(script, 'directives', {ClosePopup});
